import { render, staticRenderFns } from "./MediaEform.vue?vue&type=template&id=3871ac1e&scoped=true&"
import script from "./MediaEform.vue?vue&type=script&lang=js&"
export * from "./MediaEform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871ac1e",
  null
  
)

export default component.exports